module.exports = __webpack_public_path__ + "assets/413b23f4229838cd2ca1cc3f23cfa952.mp3";